var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0302734 2.96949C0.0302734 1.38699 1.34527 0.104492 2.96777 0.104492H37.0928C38.7153 0.104492 40.0303 1.38699 40.0303 2.96949V37.2395C40.0303 38.822 38.7153 40.1045 37.0928 40.1045H2.96777C1.34527 40.1045 0.0302734 38.822 0.0302734 37.2395V2.96949ZM12.3878 33.5895V15.527H6.38527V33.5895H12.3878ZM9.38777 13.0595C11.4803 13.0595 12.7828 11.6745 12.7828 9.93949C12.7453 8.16699 11.4828 6.81949 9.42777 6.81949C7.37277 6.81949 6.03027 8.16949 6.03027 9.93949C6.03027 11.6745 7.33277 13.0595 9.34777 13.0595H9.38777ZM21.6578 33.5895V23.502C21.6578 22.962 21.6978 22.422 21.8578 22.037C22.2903 20.9595 23.2778 19.842 24.9378 19.842C27.1103 19.842 27.9778 21.497 27.9778 23.927V33.5895H33.9803V23.2295C33.9803 17.6795 31.0203 15.0995 27.0703 15.0995C23.8853 15.0995 22.4578 16.8495 21.6578 18.082V18.1445H21.6178L21.6578 18.082V15.527H15.6578C15.7328 17.222 15.6578 33.5895 15.6578 33.5895H21.6578Z",
    fill: "#807B7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector1);
export default __webpack_public_path__ + "static/media/Vector-1.79223c1b36132d85a70d74cb52fae8c7.svg";
export { ForwardRef as ReactComponent };